import React, { Component } from 'react';
import classNames from 'classnames';
import './AirAutocomplete.css';
import { AutoComplete, Input } from 'antd';
import { MagnifierIcon } from '../../icons';

export default class AirAutocomplete extends Component {
  static Option = AutoComplete.Option;
  render() {
    const cls = classNames({
      AirAutocomplete: true,
      [this.props.className]: !!this.props.className
    });

    return (
      <AutoComplete {...this.props} className={cls} placeholder="">
        <Input placeholder={this.props.placeholder} prefix={<MagnifierIcon style={{ color: 'var(--dark-grey)', width: '20px', height: '20px' }} />} />
      </AutoComplete>
    );
  }
}



// WEBPACK FOOTER //
// ./src/common/components/AirAutocomplete/AirAutocomplete.js